// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-conditions-wrapper {
  width: 100%;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1440px;
}
.terms-conditions-wrapper .main-heading {
  display: inline-block;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  color: #7a7a7a;
  text-align: center;
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: default;
}
.terms-conditions-wrapper ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 12px;
  list-style-type: circle;
  cursor: default;
}
.terms-conditions-wrapper ul li {
  line-height: 24px;
}
.terms-conditions-wrapper .tabular-policies-section-wrapper, .terms-conditions-wrapper .non-tabular-policies-section-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
}
.terms-conditions-wrapper .tabular-policies-section-wrapper .left-wrapper, .terms-conditions-wrapper .tabular-policies-section-wrapper .right-wrapper, .terms-conditions-wrapper .non-tabular-policies-section-wrapper .left-wrapper, .terms-conditions-wrapper .non-tabular-policies-section-wrapper .right-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

@media only screen and (width <= 768px) {
  .terms-conditions-wrapper {
    padding: 10px;
  }
  .terms-conditions-wrapper .tabular-policies-section-wrapper .left-wrapper, .terms-conditions-wrapper .tabular-policies-section-wrapper .right-wrapper, .terms-conditions-wrapper .non-tabular-policies-section-wrapper .left-wrapper, .terms-conditions-wrapper .non-tabular-policies-section-wrapper .right-wrapper {
    padding: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/TermsConditions/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AACJ;AACI;EACI,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;AACR;AAEI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AAAR;AAEQ;EACI,iBAAA;AAAZ;AAII;EACI,aAAA;EACA,2DAAA;EACA,SAAA;AAFR;AAIQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAFZ;;AAOA;EACI;IACI,aAAA;EAJN;EAOU;IACI,aAAA;EALd;AACF","sourcesContent":[".terms-conditions-wrapper{\n    width: 100%;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    max-width: 1440px;\n\n    .main-heading{\n        display: inline-block;\n        width: 100%;\n        font-size: 16px;\n        font-weight: 400;\n        color: #7a7a7a;\n        text-align: center;\n        text-decoration: underline;\n        text-underline-offset: 4px;\n        cursor: default;\n    }\n\n    ul{\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        padding-left: 12px;\n        list-style-type: circle;\n        cursor: default;\n\n        li{\n            line-height: 24px;\n        }\n    }\n\n    .tabular-policies-section-wrapper, .non-tabular-policies-section-wrapper{\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n        gap: 16px;\n\n        .left-wrapper, .right-wrapper{\n            display: flex;\n            flex-direction: column;\n            gap: 16px;\n            padding: 20px;\n            border: 1px solid #ddd;\n            border-radius: 6px;\n        }\n    }\n}\n\n@media only screen and (width <= 768px) {\n    .terms-conditions-wrapper{\n        padding: 10px;\n    \n        .tabular-policies-section-wrapper, .non-tabular-policies-section-wrapper{\n            .left-wrapper, .right-wrapper{\n                padding: 14px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
